// components
import Menu from "./Menu";
import Footer from "./Footer";

const Layout = ({ children }: any) => {
  return (
    <>
      <Menu />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
